import React from 'react';
import lv from '../images/lv.png';
import chart from '../images/chart.png';
import { Divider, Grid, Header, Image, List, Segment } from 'semantic-ui-react';

const LeviAll = () => {
  return (
    <Segment raised>
      <Header as='h1' textAlign='center'>
        LeviAll
        <Header.Subheader>
          Safeguard skin health with natural yeast compounds
        </Header.Subheader>
      </Header>

      <Divider />


      <Grid stackable padded columns={2}>
        <Grid.Column textAlign='center' verticalAlign='middle'>
          <Image size='medium' centered src={lv} /><br/>

          LeviAll has the optimal composition of bioactive compounds from baker’s yeast (Saccharomyces cerevisiae) with their maximum activity due to ABAC’s proprietary isolation technology. These compounds are multiple branched α-(1,6)-mannan, ß-(1,3/1,6)-glucan, and hydrolysed yeast protein (amino acids, peptides and proteins).
        </Grid.Column>

        <Grid.Column className='large-text'>
          <List bulleted size='big'>
            <List.Item>Boosts skin regeneration</List.Item>
            <List.Item>Strengthens barrier function </List.Item>
            <List.Item>Improves skin appearance </List.Item>
            <List.Item>Prevents skin aging </List.Item>
            <List.Item>Reduces skin irritation</List.Item>
            <List.Item>Prevents hypersensitivity to repeated irritant exposure</List.Item>
          </List>

          <Image size='medium' src={chart} />
        </Grid.Column>
      </Grid>

    </Segment>
  );
}

export default LeviAll;


// WEBPACK FOOTER //
// ./src/components/LeviAll.js